import React from 'react';
import { style } from 'typestyle';
import { Row } from '@src/components/Utils';
import { Pathname } from '@src/types/Browsing';
import AuthorizedPage from '@src/components/AuthorizedPage';
import { Footer } from '@src/components/Footer';
import { ADALONG_COLORS } from '@src/styles';
import NavBar from '../../components/NavBar';
import styles from './styles.module.scss';
import { ShareCollections } from './Collections/index';
import { openSharePopup, closeSharePrompt } from '@src/state/shareAtoms';
import { useAtomValue } from 'jotai';
import { sharePopupAtom, sharePromptAtom } from '@src/state/shareAtoms';

import SharePrompt from './components/SharePrompt';
import SharePopup from './components/SharePopup';
import { ShareNetworkType, SharePopupInfo } from '@src/types/share';
import Display from './Display';
import { useQueryUserConfig } from '@src/queries/users/useQueryUserConfig';

// Open  Share modal
function openShare(target: ShareNetworkType, info: SharePopupInfo) {
  openSharePopup(target, info);
}

// Close share modal
function closeShare() {
  closeSharePrompt();
}

function Share() {
  const sharePopup = useAtomValue(sharePopupAtom);
  const sharePrompt = useAtomValue(sharePromptAtom);
  const { data: userConfig } = useQueryUserConfig();
  const user = userConfig?.user ?? null;

  return (
    <AuthorizedPage tab="share" user={user}>
      <div className={styles.page} style={{ height: window.innerHeight, display: 'flex', flexDirection: 'column', backgroundColor: ADALONG_COLORS.SMOOTH_BLACK }}>
        <div style={{ backgroundColor: ADALONG_COLORS.DARK_BLACK }}>
          <NavBar active={Pathname.share} />
        </div>
        {sharePrompt &&
          <SharePrompt
            openSharePopup={openShare}
            closeSharePrompt={closeShare}
          />
        }
        {sharePopup ? <SharePopup /> : null}
        <div className={styles.share} style={{ flex: 1 }}>
          <Row className={contentClass}>
            <ShareCollections />
            <Display />
          </Row>
        </div>
        <Footer />
      </div>
    </AuthorizedPage>
  );
}

const contentClass = style({
  position: 'relative',
  overflow: 'hidden',
  flex: 1,
});

export default Share;
